<template lang="pug">
  .ModelingSound
    .ModelingSound-close
      button.Btn.BtnIcon(@click="closePopup")
        i.Icon.IconClose
    .ModelingSound-header
      h2 Выбор мелодии

    .ModelingSound-body
      .ModelingSound-list
        .ModelingSound-item(
          v-for="(soundValue, index) in soundsList",
          :key="soundValue")
          label
            input(
              type='radio',
              name="soundInput",
              :value='soundValue',
              v-model="sound")
            span Мелодия {{index + 1}}
          button.Btn.BtnIcon(@click="playSound(soundValue)")
            i.Icon.IconServiceStart
    .ModelingSound-footer
      button.Btn.Btn--blue(
        @click="save") Сохранить
      button.Btn.Btn--grey(@click="closePopup") Отмена
</template>

<script>
  export default {
    name: 'ModelingSound',
    data() {
      return {
        sound: '',
        soundToPlay: null
      }
    },
    props: {

    },
    computed: {
      currentSelected() {
        return this.$store.getters.modelingSelectedSound
      },
      soundsMap() {
        return this.$store.getters.modelingSoundsMap
      },
      soundsList() {
        return Object.keys(this.soundsMap)
      }
    },
    mounted() {
      this.sound = this.currentSelected
    },
    methods: {
      playSound(soundValue) {
        if(this.soundToPlay) {
          this.soundToPlay.pause()
        }
        this.soundToPlay = new Audio(this.soundsMap[soundValue])
        this.soundToPlay.play()
      },
      save() {
        this.$store.commit('setModelingSelectedSound', this.sound)
        this.$ui.toast.show({text: 'Выбор мелодии сохранен на данном устройстве', type: 'success'})
        this.$ui.popup.ok()
      },
      closePopup() {
        this.$ui.popup.ok()
      },
    }
  }
</script>

<style lang="scss">
  @import "~base";

  .Popup .ModelingSound {
    --footerBorder: #{$grey3};
  }

  .Popup[data-theme='dark'] .ModelingSound {
    --footerBorder: #{$grey2};
  }
</style>
<style scoped lang="scss">
  @import '~base';

  .ModelingSound {
    position: relative;

    &-close {
      position: absolute;
      top: 10px;
      right: 15px;

      .Icon {
        font-size: 14px;
      }
    }

    &-header {
      padding: 25px 30px 0;

      h2 {
        margin-bottom: 0;
        font-size: 16px;
        text-transform: uppercase;
      }
    }

    &-body {
      padding: 25px 10px 0 30px;
    }

    &-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;

      .Btn {
        height: 20px;
        width: 20px;
        text-align: center;

        .Icon {
          color: var(--secondaryText);
          font-size: 12px;
        }

        &:hover {
          .Icon {
            color: var(--accentColor);
          }
        }
      }

      label {
        line-height: 0;
        margin-bottom: 0;

        span {
          font-size: 12px;
          line-height: 18px;
        }
      }
    }

    &-footer {
      padding: 5px 30px 10px;
      border-top: 1px solid var(--footerBorder);

      .Btn {
        min-width: 155px;
        font-size: 11px;
        font-weight: 300;
        text-transform: uppercase;
      }

      .Btn + .Btn {
        margin-left: 12px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/popups/ModelingSound.vue